<template>
  <div v-if="!isNaN(navigation.positionInList)" data-cy="filteredNavMini__container">
    <v-btn
      icon
      :disabled="!navigation.prev"
      @click="navigate(navigation.prev)"
      class="white--text"
      data-cy="filteredNavMini__button--prev"
    >
      <v-icon>fas fa-caret-left</v-icon>
    </v-btn>
    <span>
      {{ navigation.positionInList + 1 }} / {{ navigation.listLength }}
      <span v-if="filters.length">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" icon>
              <v-icon class="ml-2" color="primary lighten-4" small data-cy="filteredNavMini__icon--activeFilters"
                >fas fa-filter</v-icon
              >
            </v-btn>
          </template>
          <span>
            <div class="body-2">Active Filters ({{ filters.length }})</div>
            <ul>
              <li v-for="(filter, index) in filters" :key="index">
                {{ getFilterLabel(filter) }}
              </li>
            </ul>
          </span>
        </v-tooltip>
      </span>
    </span>
    <v-btn
      icon
      :disabled="!navigation.next"
      @click="navigate(navigation.next)"
      class="white--text"
      data-cy="filteredNavMini__button--next"
    >
      <v-icon>fas fa-caret-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { getFilterLabel } from "@/lib/formatters";

export default {
  name: "filteredNavigation",
  components: {},
  computed: {
    packId() {
      return this.$route.params.packId;
    },
    releaseNoteId() {
      return this.$route.params.releaseNoteId;
    },
  },
  data() {
    return { getFilterLabel };
  },
  methods: {
    navigate(releaseNote) {
      const query = {};
      if (!!this.$route.query.globalSearch) {
        query.globalSearch = this.$route.query.globalSearch;
      }

      const { packId, releaseNoteId } = releaseNote;
      this.$router.push({ name: "testPlanView", params: { packId, releaseNoteId }, query });
    },
  },
  props: {
    filters: {
      type: Array,
      default: [],
    },
    navigation: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
span.och-buttonText--long {
  display: inline-block;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
